module.exports = __webpack_public_path__ + "static/img/4.f362eb78.png";